module.exports = __webpack_public_path__ + "static/media/MY.21d04c18.svg";